import { TFunnel, TFunnelCampaign } from "@/models/funnels.model";
import { TAvailableWidget, TDashboardWidget, TTableColumn, TWidgetType } from "@/models/widgets.model";
import axios from "@utils/axios-instance";

export const getFunnels = async (): Promise<TFunnel[]> => {
  const response = await axios.get("/funnel");
  return response.data;
};


export const getFunnelById = async (funnelId: number, options?: { start: string, end: string }): Promise<TDashboardWidget[]> => {
  let query = "";
  if (options?.start && options?.end) query = `?start=${options.start}&end=${options.end}`;
  const response = await axios.get(`/funnel/${funnelId}${query}`);
  return response.data;
};

export const getFunnelCampaigns = async (): Promise<TFunnelCampaign[]> => {
  const response = await axios.get(`/funnel/campaigns/available`);
  return response.data;
};

export const createFunnelService = async ({ name, campaigns = [], tags = [] }: { name: string, campaigns?: TFunnelCampaign[], tags?: string[] }): Promise<TFunnel> => {
  const response = await axios.post(`/funnel`, { name, campaigns, campaignSubstrings: tags });
  return response.data;
};

export const getAvailableWidgets = async (): Promise<TAvailableWidget[]> => {
  const response = await axios.get(`/funnel/availablewidgets`);
  return response.data;
}

export const addWidgetToFunnel = async (funnelId: number, data: { type: TWidgetType, category: string }): Promise<void> => {
  await axios.post(`/funnel/${funnelId}/widget`, data);
}

export const reorderWidgets = async (funnelId: number, orderedWidgets: number[]) => {
  await axios.patch(`/funnel/${funnelId}/widget/reorder`, orderedWidgets);
}

export const updateTableWidgetColumns = async ({ funnelId, widgetId, columns }: { funnelId: number, widgetId: number, columns: TTableColumn[] }) => {
  await axios.patch(`/funnel/${funnelId}/widget/${widgetId}/columns`, { columns });
}

export const getFunnelWidgetData = async ({ funnelId, widgetId }: { funnelId: number, widgetId: number }): Promise<TDashboardWidget> => {
  const response = await axios.get(`/funnel/${funnelId}/widget/${widgetId}`);
  return response.data;
}

export const deleteFunnelService = async (funnelId: number): Promise<void> => {
  await axios.delete(`/funnel/${funnelId}`);
}

export const updateFunnelService = async ({ funnelId, name, campaigns, tags }: { funnelId: number, name: string, campaigns?: TFunnelCampaign[], tags?: string[] }): Promise<void> => {
  const response = await axios.patch(`/funnel/${funnelId}`, { name, campaigns, campaignSubstrings: tags });
  return response.data;
}

/* export const inviteUser = async (data: { email: string; role: number }) => {
  const response = await axios.post("/users/invite", data);
  return response;
};

const updateUser = async (data: TUpdateUser) => {
  const { id, ...payload } = data;
  await axios.patch(`/users/${id}`, payload);
};

const deleteuser = async (userId: number) => {
  await axios.delete(`/users/${userId}`);
}; */

export default {
  getFunnels,
  getFunnelById
};
